import React, { useEffect, useRef, useState } from "react";

const toUrl = (v) => (v && typeof v === "object" ? v.url || "" : v || "");
const toLabel = (v) => (v && typeof v === "object" ? v.label || "" : "");

export default function LinkCell({ value, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [urlDraft, setUrlDraft] = useState(toUrl(value));
  const [labelDraft, setLabelDraft] = useState(toLabel(value));
  const urlRef = useRef(null);

  useEffect(() => {
    setUrlDraft(toUrl(value));
    setLabelDraft(toLabel(value));
  }, [value]);

  useEffect(() => { if (editing) urlRef.current?.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    const url = urlDraft.trim();
    if (!url) {
      if (value) onCommit(null);
      return;
    }
    if (url !== toUrl(value) || labelDraft !== toLabel(value)) {
      onCommit({ url, label: labelDraft.trim() });
    }
  };

  if (editing && !readOnly) {
    return (
      <div className="cell-display link-edit">
        <input
          ref={urlRef}
          className="cell-input"
          placeholder="https://..."
          value={urlDraft}
          onChange={(e) => setUrlDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") setEditing(false);
            if (e.key === "Enter") commit();
          }}
        />
        <input
          className="cell-input"
          placeholder="label (optional)"
          value={labelDraft}
          onChange={(e) => setLabelDraft(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === "Escape") setEditing(false);
            if (e.key === "Enter") commit();
          }}
        />
      </div>
    );
  }

  const url = toUrl(value);
  const label = toLabel(value);
  return (
    <div className={`cell-display link ${readOnly ? "read-only" : ""}`}>
      {url ? (
        <>
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="link-url"
            onClick={(e) => e.stopPropagation()}
          >
            {label || url}
          </a>
          {!readOnly && (
            <button className="link-edit-btn" onClick={() => setEditing(true)} title="Edit">✎</button>
          )}
        </>
      ) : (
        <span className="placeholder" onClick={() => !readOnly && setEditing(true)}>—</span>
      )}
    </div>
  );
}
